import { Modal, List, Button, Tag, Empty } from "antd";
import { Building2, User } from "lucide-react";
import dayjs from "dayjs";

function GroupsListModal({
  visible,
  groups,
  type, // 'ingreso', 'egreso' o 'activos'
  date,
  onClose,
  onSelectGroup,
}) {
  const getTitleAndTag = () => {
    switch (type) {
      case "ingreso":
        return {
          title: `Grupos que ingresan - ${dayjs(date).format("DD/MM/YYYY")}`,
          tagColor: "blue",
          tagText: "Check-in",
        };
      case "egreso":
        return {
          title: `Grupos que egresan (Rendición) - ${dayjs(date).format("DD/MM/YYYY")}`,
          tagColor: "orange",
          tagText: "Check-out / Rendición",
        };
      case "activos":
        return {
          title: `Grupos activos - ${dayjs(date).format("DD/MM/YYYY")}`,
          tagColor: "green",
          tagText: "Activos",
        };
      default:
        return {
          title: `Grupos - ${dayjs(date).format("DD/MM/YYYY")}`,
          tagColor: "default",
          tagText: type,
        };
    }
  };

  const { title, tagColor, tagText } = getTitleAndTag();

  return (
    <Modal
      title={
        <div className="flex items-center gap-2">
          <span>{title}</span>
          <Tag color={tagColor}>{tagText}</Tag>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          Cerrar
        </Button>,
      ]}
      width={600}
    >
      {groups && groups.length > 0 ? (
        <List
          dataSource={groups}
          renderItem={(group) => (
            <List.Item
              actions={[
                <Button
                  key="detail"
                  type="primary"
                  size="small"
                  onClick={() => onSelectGroup(group)}
                >
                  Ver detalle
                </Button>,
              ]}
            >
              <List.Item.Meta
                avatar={
                  <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
                    <Building2 size={20} className="text-blue-600" />
                  </div>
                }
                title={group.company?.name || "Sin empresa"}
                description={
                  <div className="flex flex-col gap-1">
                    <span className="flex items-center gap-1">
                      <User size={14} />
                      Coordinador:{" "}
                      {group.coordinator
                        ? `${group.coordinator.firstName} ${group.coordinator.lastName || ""}`
                        : "-"}
                    </span>
                    <span className="text-gray-400 text-xs">
                      {dayjs(group.checkInDate).format("DD/MM")} →{" "}
                      {dayjs(group.checkOutDate).format("DD/MM")} (
                      {dayjs(group.checkOutDate).diff(
                        dayjs(group.checkInDate),
                        "day"
                      )}{" "}
                      noches)
                    </span>
                  </div>
                }
              />
            </List.Item>
          )}
        />
      ) : (
        <Empty description="No hay grupos para esta fecha" />
      )}
    </Modal>
  );
}

export default GroupsListModal;
